export const characterSettingFeatureTranslationJP = {
  characterSettingList: {
    title: 'キャラクターー覧',
    add: '新規追加',
    detail: '詳細',
    delete: '削除',
    restore: '復元',
    table: {
      select: '選択',
      character_name: 'キャラクター名',
      image: '画像',
      image_1: 'キャラクター 1',
      image_2: 'キャラクター 2',
      idle_time: '表示待機時間',
      default: '適用',
    },
    add_title: 'キャラクター設定追加',
    add_placeholder: 'キャラクター名を入力してください',
    create: '作成',
    delete_confirm: '選択したキャラクターを削除してもよろしいですか？',
    delete_confirm_on:
      '選択したキャラクターを削除します。適用に設定されたキャラクターも削除され、キャラクター表示がオフになります。よろしいですか？',
    delete_confirm_off: '選択したキャラクターを削除します。よろしいですか？',
    delete_confirm_all: 'すべてのキャラクターを削除すると、キャラクター表示がオフになります。よろしいですか？',
    restore_confirm: '選択したキャラクターを復元します。よろしいですか？',
    restore_success: 'キャラクターを復元しました。',
    delete_success: 'キャラクターを削除しました。',
    default_update_success: 'キャラクターの適用が更新されました。',
  },
  characterSettingDetail: {
    detail_title: 'キャラクター詳細',
    character_name: '名称',
    enter_character_name: 'キャラクター名を入力してください',
    character_image: '画像',
    image_1: 'キャラクター 1',
    image_2: 'キャラクター 2',
    idle_time: '表示待機時間（秒）',
    default_character: '適用キャラクター',
    click_to_upload: 'クリックしてアップロード',
    edit_character: 'キャラクター編集',
    add_character: 'キャラクター追加',
    name_required: 'キャラクター名は必須です',
    idle_time_required: '表示待機時間は必須です',
    image_1_required: 'キャラクター1の画像は必須です',
    image_2_required: 'キャラクター2の画像は必須です',
    update_feature_not_available: '更新機能は現在利用できません',
    save_success: 'キャラクター情報を保存しました',
    create_success: 'キャラクターを作成しました',
  },
  common: {
    save: '保存',
    cancel: 'キャンセル',
    loading: '読み込み中...',
  },
};
